import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** Get SmartTransfers Requests Received List
@docs Não há documentação
*/
export const getSmartTransfersRequestsReceivedList = (payload) => {
    return httpClient({
		method: 'GET',
		url: 'smart-transfer/request/received/search',
        params: payload.params,
		isCancellable: true
	})
}

/** Get SmartTransfers Requests Sent List
@docs Não há documentação
*/
export const getSmartTransfersRequestsSentList = (payload) => {
    return httpClient({
		method: 'GET',
		url: 'smart-transfer/request/sent/search',
        params: payload.params,
		isCancellable: true
	})
}

/** Get SmartTransfers Requests Status List
@docs Não há documentação
*/
export const getSmartTransfersRequestsStatusList = () => {
    return httpClient({
		method: 'GET',
		url: 'smart-transfer/request/status',
		isCancellable: true
	})
}

/** Reject SmartTransfer Received Request
@docs Não há documentação
*/
export const rejectSmartTransferReceivedRequest = (payload) => {
    return httpClient({
		method: 'PUT',
		url: `/smart-transfer/request/${payload}/reject`
	})
}

/** Cancel SmartTransfer Request
@docs Não há documentação
*/
export const cancelSmartTransferRequest = (payload) => {
    return httpClient({
		method: 'PUT',
		url: `/smart-transfer/request/${payload}/cancel`
	})
}

/** Create a SmartTransfer Send Money
@docs Não há documentação
*/
export const createSmartTransferSendMoney = (payload) => {
    return httpClient({
		method: 'POST',
		url: 'smart-transfer/submission',
		data: payload,
		operationTypeId: 32009 /* for mocks handling of tokens */
	})
}

/** Get SmartTransfers Submissions Sent List
@docs Não há documentação
*/
export const getSmartTransfersSubmissionsSentList = (payload) => {
    return httpClient({
		method: 'GET',
		url: 'smart-transfer/submission/sent/search',
        params: payload.params,
		isCancellable: true
	})
}

/** Create a SmartTransfer request
@docs Não há documentação
*/
export const createSmartTransferRequest = (payload) => {
    return httpClient({
		method: 'POST',
		url: 'smart-transfer/request',
		data: payload.data
	})
}

/** Sends smart transfer email
@docs Não há documentação
*/
export const sendSmartTransferSubmissionEmailNotification = (payload) => {
	return httpClient({
		method: 'POST',
		url: `smart-transfer/submission/${payload.operationID}/notification/email`,
		data: payload.data
	})
}

/** Sends smart transfer sms
@docs Não há documentação
*/
export const sendSmartTransferSubmissionSmsNotification = (payload) => {
    return httpClient({
		method: 'POST',
		url: `smart-transfer/submission/${payload.operationID}/notification/sms`,
		data: payload.data
	})
}

/** Creates an url for download of smartTransfer receipt
@docs Não há documentação
*/
export const createSmartTransferDownloadReceiptURL = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: 'smart-transfer/request/generateSmartTransferRequestReceipt',
		params: payload.params,
		isCancellable: true
	})
}

/** Checks contacts list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_contacts
*/
export const contacts = payload => {
    return httpClient({
        method: 'POST',
        url: 'smart-transfer/contacts',
        data: payload.data
    })
}
